const styles = theme => ({
  app: {
    height: '100%'
  },
  version: {
    position: 'fixed',
    bottom: 0,
    left: 8,
    zIndex: 1000,
    opacity: 0.4,
    textShadow: '0px 0px 2px #fff'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/App/styles.js